<template>
  <div class="add-pay-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-table
        :data="tableData2"
        style="width: 100%"
        max-height='600px'
        border
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column
          prop="episodeNumber"
          label="第几集"
          align="center"
          fixed
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ '第' + scope.row.episodeNumber + '集' || '未知' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="listenPermission"
          label="收听权限"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.listenPermission | listenPermissions }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="price"
          label="购买价格"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.price }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="name"
          label="章节名"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="contentUrl"
          label="资源地址"
          align="center"
          min-width="100"
          v-if="this.dialogVisible === true"
        >
          <template slot-scope="scope">
            <audio-player
              ref="audioPlayer"
              :show-prev-button="false"
              :show-next-button="false"
              :show-volume-button="false"
              :audio-list="['https://yuan.dhuqh.com/' + scope.row.contentUrl]"
            />
          </template>
        </el-table-column>

        <el-table-column
          prop="mediaSize"
          label="资源大小"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.mediaSize }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      type: '',
      dialogVisible: false,
      title: '',
      tableData2: [],
      params_detail: {}
    }
  },
  methods: {  
    // 关闭详情弹窗
    handleClose() {
      this.dialogVisible = false
    },
    // 打开详情弹窗
    open(data) {
      this.dialogVisible = true
      this.params_detail = data
      this.tableData2 = data.contentSet
      this.title = '章节(内容集)详情'
    },
  },
}
</script>

<style lang="scss" scoped>
.add-pay-box {
  .el-date-picker,
  .el-input {
    width: 150px;
  }
  .form_item {
    margin-top: 10px;
  }
  .protocol {
    font-size: 10px;
    margin-left: 10px;
    color: green;
  }
}
</style>
<style lang="scss" >
.audio-player .audio__play-icon {
  width: 80%;
  height: 100%;
  fill: currentColor;
  overflow: hidden;
  color: #e35924;
}
</style>